@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Indiana</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">

      <!-- Liability Limit -->
      <div class="axis-grid">
        @if ((baseRules?.UMPD_LiabilityLimit_DropDown ?? "").includes("readonly")) {
          <div class="axis-col-sm-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[10].label }} </label>
              <div>{{ controls[10].data[0].name }}</div>
            </div>
          </div>
        }
      </div>
      <div class="axis-grid">
        @if ((baseRules?.UIM_LiabilityLimit_DropDown ?? "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label id="uim_liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-indiana" class="axis-control-label"> {{ controls[9].label }} </label>
              <div>{{ controls[9].data[0].name }}</div>
            </div>
          </div>
        }
      </div>
      <!-- Deductible Radio heading -->
      @if ((baseRules?.Deductible_Label ?? "").includes("readonly")) {
        <label class="axis-control-label">{{ textValues?.Deductible_Label }}</label>
      }
      <!--Deductible Radio level one-->
      @if (controls?.length) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      @if (
        baseRules?.SelectPDND_UM_LevelTwo_Radio === "show" ||
        baseRules?.RejectPD_UM_LevelTwo_Radio === "Yes" ||
        baseRules?.SelectPD300_UM_LevelTwo_Radio === "show" ||
        baseRules?.SelectBIPD300_UM_LevelTwo_Radio === "show"
      ) {
        <h3 class="axis-h5">UM Coverage:</h3>
      }
      <!-- UM Radio group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UM Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 3 : 7; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      <!--UIM Readonly split-->
      @let L1_CTRL = controls[0].formControlName;
      @let l1Val = reactiveForm?.get(L1_CTRL)?.value;
      @let l1Key = (l1Val?.select ?? l1Val?.value ?? l1Val) || "";
      
      @if (l1Key === "NoDeductible_LevelOne_Radio") {
        @if ((baseRules?.["UM_NDMin_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[5].label }}</label>
              <div id="um_ndmin_25k-pdffield-indiana">{{ controls[5].data[0].name }}</div>
            </div>
          </div>
        </div>
        }
        @if ((baseRules?.["SelectBIPDND_UM_LevelTwo_Radio"] ?? "").includes("Yes")) {
        <div class="axis-grid">
          <div class="axis-col-auto">
            <div class="axis-form-group">
              <label id="selectbipdnd_um_leveltwo_radio-pdffield-indiana" class="axis-control-label">{{
                textValues?.Select_BIPD_ND_UM_Text }}</label>
            </div>
          </div>
        </div>
        }
        @if ((baseRules?.["Split_UIM_LevelTwo_Radio"] ?? "").includes("Yes")) {
        <div class="axis-grid">
          <div class="axis-col-auto">
            <div class="axis-form-group">
              <label id="combined_uim_leveltwo_radio-pdffield-indiana" class="axis-control-label">{{ textValues?.Split_UIM_Text
                }}</label>
            </div>
          </div>
        </div>
        }
      }
      @if (l1Key === "300Deductible_LevelOne_Radio") {
        @if ((baseRules?.["UM_300Min_DropDown"] || "").includes("readonly")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[6].label }}</label>
              <div id="um_300min_25k-pdffield-indiana">{{ controls[6].data[0].name }}</div>
            </div>
          </div>
        </div>
        }
        @if ((baseRules?.["SelectBIPD300_UM_LevelTwo_Radio"] ?? "").includes("Yes")) {
        <div class="axis-grid">
          <div class="axis-col-auto">
            <div class="axis-form-group">
              <label id="selectbipd300_um_leveltwo_radio-pdffield-indiana" class="axis-control-label">{{
                textValues?.Select_BIPD_300_UM_Text }}</label>
            </div>
          </div>
        </div>
        }
        
        @if ((baseRules?.["Split_UIM_LevelTwo_Radio"] ?? "").includes("Yes")) {
        <div class="axis-grid">
          <div class="axis-col-auto">
            <div class="axis-form-group">
              <label id="combined_uim_leveltwo_radio-pdffield-indiana" class="axis-control-label">{{ textValues?.Split_UIM_Text
                }}</label>
            </div>
          </div>
        </div>
        }
        @if ((baseRules?.["SelectPD300_UM_LevelTwo_Radio"] ?? "").includes("Yes")) {
        <div class="axis-grid">
          <div class="axis-col-auto">
            <div class="axis-form-group">
              <label id="split_uim_leveltwo_radio-pdffield-indiana" class="axis-control-label">{{
                textValues?.Select_PD_300_UM_Text }}</label>
            </div>
          </div>
        </div>
        }
      }
    
      <!-- UM Readonly fields -->

      @if (baseRules?.UM_300Min_DropDown === "Yes") {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">
                {{ controls[6].label }}
              </label>
              <div>{{ controls[6].data[0].name }}</div>
            </div>
          </div>
        </div>
      }

      @if (baseRules?.UM_NDMin_DropDown === "Yes") {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">
                {{ controls[5].label }}
              </label>
              <div>{{ controls[5].data[0].name }}</div>
            </div>
          </div>
        </div>
      }
      <!--UM Read only-->
      @if ((baseRules?.["RejectPD_UM_LevelTwo_Radio"] ?? "").includes("Yes")) {
        <div class="axis-grid">
          <div class="axis-col-auto">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ textValues?.Reject_PD_UM_Text }}</label>
            </div>
          </div>
        </div>
      }

      @if (baseRules?.Split_UIM_LevelTwo_Radio === "show" || baseRules?.Combined_UIM_LevelTwo_Radio === "show") {
        <h3 class="axis-h5">UIM Coverage:</h3>
      }
      <!-- UIM Radio group level one -->
      @if (controls?.length >= 3) {
        <div
          class="axis-form-group _mt-large"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UIM Dropdown -->
      <div class="axis-grid">
        @for (control of controls | slice: 7; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select an option.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      
      @if ((baseRules?.["Combined_UIM_LevelTwo_Radio"] ?? "").includes("Yes")) {
        <div class="axis-grid">
          <div class="axis-col-auto">
            <div class="axis-form-group">
              <label
                id="combined_uim_leveltwo_radio-pdffield-indiana"
                class="axis-control-label"
                >{{ textValues?.Combined_UIM_Text }}</label
              >
            </div>
          </div>
        </div>
      }
    </form>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Indiana</h2>

  <!-- Liability Limit -->
  <div class="axis-grid">
    @if ((baseRules?.UM_LiabilityLimit_DropDown ?? "").includes("readonly")) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label">{{ controls[8].label }} </label>
          <div>{{ controls[8].data[0].name }}</div>
        </div>
      </div>
    }
    @if ((baseRules?.UIM_LiabilityLimit_DropDown ?? "").includes("readonly")) {
      <div class="axis-col-sm-6 axis-col-lg-4">
        <div class="axis-form-group">
          <label class="axis-control-label"> {{ controls[9].label }} </label>
          <div>{{ controls[9].data[0].name }}</div>
        </div>
      </div>
    }
  </div>
  <!-- Reject texts -->
  @if (baseRules?.Reject_UM_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
    </div>
  }

  @if (baseRules?.RejectPD_UM_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_PD_UM_Text }}
      </label>
    </div>
  }

  @if (baseRules?.Split_UIM_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Select_UIM_Text }}
      </label>
    </div>
  }

  @if (baseRules?.Reject_UIM_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_UIM_Text }}
      </label>
    </div>
  }

  @if (baseRules?.Combined_UIM_LevelTwo_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Combined_UIM_Text }}
      </label>
    </div>
  }
}
